/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_Meta_DescInputs */

const en_simple_mulai_meta_desc = /** @type {(inputs: Simple_Mulai_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three ways to turn an idea into an app other people can open on their phone.`)
};

const id_simple_mulai_meta_desc = /** @type {(inputs: Simple_Mulai_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga cara mengubah ide jadi aplikasi yang bisa dibuka orang lain di HP.`)
};

/**
* | output |
* | --- |
* | "Three ways to turn an idea into an app other people can open on their phone." |
*
* @param {Simple_Mulai_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_meta_desc = /** @type {((inputs?: Simple_Mulai_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_meta_desc(inputs)
	return en_simple_mulai_meta_desc(inputs)
});